import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, LabelList } from "recharts";

export default function AttendanceSummarySimpleChart({ summary }) {
  const data = summary.map(p => ({
    name: p.name,
    attendance: p.total,
  }));

  const chartHeight = Math.max(400, summary.length * 50); 

  return (
    <div className="w-full" style={{ height: chartHeight }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          layout="vertical" // players on Y-axis for readability
          barCategoryGap="25%"
          margin={{ top: 10, right: 10, left: 0, bottom: 50 }}
        >
          <XAxis type="number" />
          <YAxis dataKey="name" type="category" tick={{ fontSize: 12 }} width={100} />
          <Tooltip />
          <Legend
            verticalAlign="bottom"
            align="center"
            wrapperStyle={{ paddingTop: 20 }}
          />
          <Bar dataKey="attendance" fill="#2563eb" name="Total Attendance">
            <LabelList dataKey="attendance" position="right" fill="#000" fontSize={12} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
